import { render, staticRenderFns } from "./ButtonFilled.vue?vue&type=template&id=16bf87ea&scoped=true&"
import script from "./ButtonFilled.vue?vue&type=script&lang=js&"
export * from "./ButtonFilled.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFilled.vue?vue&type=style&index=0&id=16bf87ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bf87ea",
  null
  
)

export default component.exports